import { render, staticRenderFns } from "./PostSettingsAuthors.vue?vue&type=template&id=380a997d&scoped=true"
import script from "./PostSettingsAuthors.vue?vue&type=script&lang=js"
export * from "./PostSettingsAuthors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a997d",
  null
  
)

export default component.exports